import axios from 'axios';
import config from '../config/config';
import { joinApiUrl } from '../config/api-url';

export const PACKAGE_HINT = 'Die Online-Zahlfunktion ist Teil des Pakets „Online-Zahlfunktion“. Sie können das Paket unter „Pakete und Erweiterungen“ buchen. Anschließend können Sie Ihren Zahlungsdienstleister mit Stripe verbinden.';
export const OWN_PROVIDER = 'zahldienst_eigenenZahlungsdienstleisterFestlegen';
const unavailable = () => ({ PackageActive: false, StripeConnected: false, HasProductOrder: false,
  CanEnable: false, Reason: 'Die Zahlungsfreigabe konnte nicht geprüft werden. Bitte laden Sie die Seite erneut.' });
const url = path => joinApiUrl(config.API_URL, 'api/payment-eligibility' + path);
function headers() {
  const token = window.getOzgUserToken?.() || localStorage.getItem('ozgUserJwt') || localStorage.getItem('ozgJwt');
  return token ? { Authorization: 'Bearer ' + token } : {};
}
export function normalizeEligibility(data) {
  if (!data) return unavailable();
  const get = key => data[key] ?? data[key[0].toLowerCase() + key.slice(1)];
  const result = { PackageActive: get('PackageActive') === true, StripeConnected: get('StripeConnected') === true,
    HasProductOrder: get('HasProductOrder') === true, UserAllowed: get('UserAllowed') === true,
    SystemAdmin: get('SystemAdmin') === true, IsTestConnection: get('IsTestConnection') === true, Reason: get('Reason') || null };
  result.CanConfigure = result.SystemAdmin || (result.PackageActive && result.UserAllowed);
  result.CanEnable = result.CanConfigure && result.StripeConnected && result.HasProductOrder;
  return result;
}
export async function loadEligibility() {
  try { return normalizeEligibility((await axios.get(url(''), { headers: headers() })).data); }
  catch (_) { return unavailable(); }
}
export async function prepareRows(rows) {
  rows.forEach(row => { row.paymentEligibility = unavailable(); row.paymentSaved = row.item.hasPayment === true; row.paymentSaving = false; });
  const ids = [...new Set(rows.map(row => Number(row.item.formId.id)).filter(id => id > 0))];
  for (let i = 0; i < ids.length; i += 200) {
    try {
      const response = await axios.post(url('/forms'), ids.slice(i, i + 200), { headers: headers() });
      rows.forEach(row => { if (response.data[row.item.formId.id]) row.paymentEligibility = normalizeEligibility(response.data[row.item.formId.id]); });
    } catch (_) { /* The failed batch remains locked. */ }
  }
}
export async function setPayment(row, enabled) {
  const previous = row.paymentSaved === true;
  if (row.paymentSaving || !row.paymentEligibility?.CanConfigure || (enabled && !row.paymentEligibility?.CanEnable)) { row.item.hasPayment = previous; return; }
  if (!window.confirm(enabled ? 'Wollen Sie die Bezahlfunktion für dieses Formular aktivieren?' : 'Wollen Sie die Bezahlfunktion für dieses Formular deaktivieren?')) {
    row.item.hasPayment = previous;
    return;
  }
  row.paymentSaving = true;
  try {
    const response = await axios.put(url('/assignments/' + row.id), { enabled: !!enabled }, { headers: headers() });
    row.paymentSaved = response.data.hasPayment === true;
    row.item.hasPayment = row.paymentSaved;
  } catch (error) {
    row.item.hasPayment = previous;
    window.alert(error.response?.data?.message || 'Die Zahlungsänderung konnte nicht gespeichert werden.');
  } finally { row.paymentSaving = false; }
}

function walk(nodes, visitor) {
  if (!nodes || typeof nodes !== 'object') return;
  if (Array.isArray(nodes)) { nodes.forEach(node => walk(node, visitor)); return; }
  visitor(nodes);
  ['components', 'columns', 'rows', 'tabs'].forEach(key => walk(nodes[key], visitor));
}
const paymentContexts = new WeakMap();
export function applyPaymentDefinition(definition, eligibility) {
  // Never create or rewrite components. Stored Form.io settings own presentation.
  paymentContexts.set(definition, { ozgPayment: normalizeEligibility(eligibility) });
  return definition;
}
export function evaluationContext(definition) {
  return paymentContexts.get(definition) || { ozgPayment: unavailable() };
}
export async function loadEvaluationContext(definition) {
  let needed = false;
  walk(definition, c => { if (c.type === 'connecttostripe') needed = true; });
  if (needed) applyPaymentDefinition(definition, await loadEligibility());
  return evaluationContext(definition);
}
export function applyGlobalPackageForms(definition) {
  let formAdministration, fallback, existing;
  walk(definition, component => {
    if (component.key === 'formularadministration') formAdministration = component;
    if (component.key === 'ozgGlobalPackageFormsPanel') existing = existing || component;
    const title = String(component.title || component.label || '').toLowerCase();
    if ((component.type === 'panel' || component.type === 'tab' || (!component.type && Array.isArray(component.components))) && /globale.*paketdefinition/.test(title)) {
      fallback = fallback || component;
    }
  });
  const destination = formAdministration || fallback;
  if (!destination) return definition;
  const panel = existing || { type: 'panel', key: 'ozgGlobalPackageFormsPanel', input: false,
    components: [{ type: 'ozgpackageforms', key: 'ozgGlobalPackageForms', input: false }] };
  panel.title = panel.label = 'Formularpaket erstellen';
  // Reparent the existing runtime panel; keep its component configuration intact.
  function removePanel(node) {
    if (Array.isArray(node)) {
      for (let i = node.length - 1; i >= 0; i--) { if (node[i] === panel) node.splice(i, 1); else removePanel(node[i]); }
    } else if (node && typeof node === 'object') ['components', 'columns', 'rows', 'tabs'].forEach(key => removePanel(node[key]));
  }
  removePanel(definition);
  destination.components = destination.components || [];
  destination.components.push(panel);
  return definition;
}
export async function prepareDefinition(definition) {
  applyGlobalPackageForms(definition);
  await loadEvaluationContext(definition);
  return definition;
}
window.OzgPayment = { prepareRows, setPayment, prepareDefinition, loadEligibility, evaluationContext, loadEvaluationContext };
